import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getSessionIssueTypes } from 'src/apps/mfa/services/MfaSingleSessionService';
import { MFA_SESSION_ISSUE_TYPES } from 'src/common/providers/reactQueryProvider/QueryKeys';
import { MobileIssueTypeCount } from 'src/common/types/MobileSingleSessionTypes';

interface IUseMfaSessionIssueTypesQuery {
	sessionId: string;
}

export const useMfaSessionIssueTypesQuery = ({
	sessionId
}: IUseMfaSessionIssueTypesQuery): UseQueryResult<MobileIssueTypeCount[]> => {
	const componentsQuery = useQuery(
		[MFA_SESSION_ISSUE_TYPES, sessionId],
		async (): Promise<MobileIssueTypeCount[]> =>
			getSessionIssueTypes({
				sessionId
			}),
		{
			refetchOnWindowFocus: 'always'
		}
	);

	return componentsQuery;
};
